import React from "react"
import {RouterLink} from "@irati/ui/src/Link"
import isMobileDevice from "@irati/utils/mobile"
import tracking from "@irati-tracking/recognition/navigation"

interface CardContainerProps {
  children: JSX.Element
  app: string
  to: string
}
const CardContainer: React.FC<CardContainerProps> = ({children, app, to}) => {
  if (!isMobileDevice()) {
    return children
  }
  return (
    <RouterLink app={app} to={to} onClick={tracking.openRewardWallet}>
      {children}
    </RouterLink>
  )
}

export default CardContainer
